<template>
  <v-container class="home">
    <v-row class="mt-6" justify="center">
      <v-col sm12 md12 class="d-flex flex-column justify-center mx-12 left-col">
        <h1>The home for academic research posters.</h1>
        <p class="mt-8 mb-8">
          Share your poster and discover others from around the world.

          <!-- value is peer validation -->

          <!-- <br />Discuss ideas and disseminate your knowledge. <br />PosterDay is
          free to use, and community supported! -->
        </p>
        <router-link to="/upload">
          <v-btn x-large color="primary"
            >Upload Your Poster
            <v-icon class="pl-4" title="Views">mdi-arrow-right</v-icon></v-btn
          >
        </router-link>
      </v-col>
      <v-col sm12 md12>
        <v-img
          class="illustration"
          src="@/assets/3d-main-illustration.png"
        ></v-img>
      </v-col>
    </v-row>

    <v-row
      style="background-color: #ebf4ff"
      justify="center"
      align="center"
      class="mt-12 mb-12 pt-4"
    >
      <h2 class="mr-12">Become an early user!</h2>
      <v-form
        action="https://getform.io/f/9d0bba9d-b70b-41e8-a83a-b2d97b8fcc63"
        method="POST"
        class="early-user-form"
      >
        <v-layout>
          <v-text-field class="mr-4" label="Name" type="text" name="name" />
          <v-text-field class="mr-4" label="Email" type="email" name="email" />
          <v-btn outlined x-large color="primary" type="submit">Send</v-btn>
        </v-layout>
      </v-form>
    </v-row>

    <v-container>
      <Grid ref="gridComponent" />
      <!-- TODO -->
      <!-- <v-tabs fixed-tabs background-color="#f6f3e5" class="mb-6">
        <v-tab>Newest</v-tab>
        <v-tab>Popular</v-tab>
        <v-tab>Clubs</v-tab>
      </v-tabs> -->
    </v-container>
    <v-row justify="center" class="mt-8">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            @click="previous"
            :disabled="isPreviousDisabled"
            color="primary"
            fab
            x-large
            dark
            class="mr-6"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
        </template>
        <span>Previous results</span>
      </v-tooltip>

      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            @click="next"
            :disabled="isNextDisabled"
            color="primary"
            fab
            x-large
            dark
            class="ml-6"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </template>
        <span>Next results</span>
      </v-tooltip>
    </v-row>
  </v-container>
</template>

<script>
import Grid from "../components/Grid";
import { mapState } from "vuex";

export default {
  name: "Home",
  components: {
    Grid,
  },
  computed: {
    ...mapState(["isNextDisabled", "isPreviousDisabled"]),
  },
  data: () => ({}),
  methods: {
    next() {
      this.$refs.gridComponent.paginateNext();
    },
    previous() {
      this.$refs.gridComponent.paginatePrevious();
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  text-align: center;
  h1 {
    font-family: "Playfair Display";
    font-weight: 900;
    font-size: 3.5rem;
    @media screen and (max-width: 800px) {
      line-height: 3rem;
      font-size: 2.2rem;
    }
  }

  h2 {
    font-family: "Playfair Display";
  }

  .illustration {
    width: 40rem;
    @media screen and (max-width: 800px) {
      // transform: scale(0.7);
    }
  }

  .left-col {
    text-align: left;
  }

  .early-user-form {
    margin: 0 1rem;
    margin-top: 1rem;
  }
}
</style>
